import { memo } from 'react';

import Box from '@zenbusiness/zui/Box';
import CircularProgress from '@zenbusiness/zui/CircularProgress';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';
import PropTypes from 'prop-types';

import NameIcon from '#client/components/NameIcon';

import { AccountWrapper } from './AccountCommon.styles';
import Label from './Label';

function AccountCommon({
  name,
  numberOfCharacters = 2,
  title,
  subtitle,
  onClick,
  loading,
  disabled,
  statuses = []
}) {
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  return (
    <AccountWrapper
      aria-label="account"
      disabled={disabled}
      onClick={disabled ? () => {} : onClick}
      role="button"
    >
      <Stack
        alignItems="center"
        direction="row"
        spacing="16px"
        width="100%"
      >
        <Box>
          <NameIcon
            circle
            name={name}
            numberOfCharacters={numberOfCharacters}
          />
        </Box>
        <Stack
          alignItems={isMobile ? 'left' : 'center'}
          direction={isMobile ? 'column' : 'row'}
          flexGrow={5}
          gap="4px"
          justifyContent={isMobile ? 'unset' : 'space-between'}
        >
          <Stack
            alignItems="start"
            spacing="4px"
          >
            <Text
              color="primary"
              sx={{ fontSize: isMobile ? '16px' : '18px' }}
              weight="medium"
            >
              {title}
            </Text>
            <Text
              color="secondary"
              size="xs"
            >
              {subtitle}
            </Text>
          </Stack>
          <Stack
            direction="row"
            gap="8px"
          >
            {statuses.map(({ status, bgColor, color }) => (
              <Label
                bgColor={bgColor}
                color={color}
                key={status}
                status={status}
              />
            ))}
          </Stack>
        </Stack>
        <Stack
          alignItems="center"
          height={44}
          justifyContent="center"
          width={44}
        >
          {loading ? (
            <CircularProgress
              color="primary"
              size={16}
            />
          ) : (
            <SharedAsset
              alt=""
              src="/s2/icon/arrow-sm-right-fill.svg"
              width={20}
            />
          )}
        </Stack>
      </Stack>
    </AccountWrapper>
  );
}

AccountCommon.propTypes = {
  name: PropTypes.string.isRequired,
  numberOfCharacters: PropTypes.number,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  statuses: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string.isRequired,
      bgColor: PropTypes.string,
      color: PropTypes.string
    })
  )
};

export default memo(AccountCommon);
